import React, { useState, useRef } from 'react';
import {useNavigate} from 'react-router-dom';

import { sendMail } from '../consultApi';
import Spinner from './components/spinner.js';


export const ContactUs = () => {
  const [loading, setLoading] = useState(false);
  const [mapValues, setMapValues] = useState({ reason: 'Kaupimas jūsų ateičiai' });
  const form = useRef();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMapValues({
      ...mapValues,
      [name]: value,
    });
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      const response = await sendMail(mapValues); // Wait for the sendMail response
      if (response.status === 200) {
        navigate('/nukreipimas');
      } else {
        // Handle non-successful responses
        console.error('Failed to send email:', response);
        alert('Nepavyko išsiųsti. Bandykite dar kartą.');
      }
    } catch (error) {
      // Handle errors
      console.error('Error sending email:', error);
      alert('Įvyko klaida. Bandykite dar kartą.');
    } finally {
      setLoading(false);
    }
  };

  return (<div>
    <div className="consultHeader">
      <h1 className="consultInfoHeader">Registruokis Konsultacijoms</h1>
    </div>
    <div className="consultText">
      <p className='consultP'>Suprasti apie finansų ir turto valdymo galimybes yra būtina. Bet, būkime nuoširdūs, ne visi turi laiko gilintis ir
        noro tapti finansų ekspertais. Asmeninių finansų konsultacija gali būti aktuali tada, kai nori turėti aiškų ir
        įveikiamą planą, nesijaudindamas (-a) dėl pastoviai vykstančių pokyčių gyvenime. Registruokitės jau dabar, apačioje!</p>

      <form className="consultParent" ref={form} onSubmit={sendEmail}>
        <label className="cunsultLabel">Gauk nemokamą konsultaciją!</label>
        <label className='consultInput' >Vardas*</label>
        <input className='inputField' type="text" name="first_name" onChange={handleInputChange} required />
        <label className='consultInput' >Pavardė*</label>
        <input className='inputField' type="text" name="last_name" onChange={handleInputChange} required />
        <label className='consultInput' >Elektroninis paštas*</label>
        <input className='inputField' type="email" name="email_adress" onChange={handleInputChange} required />
        <label className='consultInput' >Telefono numeris*</label>
        <input className='inputField' type="text" name="phone_number" onChange={handleInputChange} required />
        <label className='consultInput' >Konsulatcijos priežastis/tipas*</label>
        <select name="reason" className='inputField' defaultValue={"Kaupimas jūsų ateičiai"} onChange={handleInputChange} required>
          {/* <option disabled selected value> </option> */}
          <option value="Kaupimas jūsų ateičiai" name="reason" onChange={handleInputChange}>Kaupimas jūsų ateičiai</option>
          <option value="Kaupimas vaiko ateičiai" name="reason" onChange={handleInputChange}>Kaupimas vaiko ateičiai</option>
          <option value="Pensijų II ir III pakopos" name="reason" onChange={handleInputChange}>Pensijų II ir III pakopos</option>
          <option value="Draudimai" name="reason" onChange={handleInputChange}>Draudimai</option>
          <option value="Esamos sutarties peržiūra" name="reason" onChange={handleInputChange}>Esamos sutarties peržiūra</option>
          <option value="Investiciniai Fondai" name="reason" onChange={handleInputChange}>Investiciniai Fondai</option>
          <option value="Bazinės žinios" name="reason" onChange={handleInputChange}>Bazinės žinios</option>
          <option value="Kita" name="reason">Kita</option>
        </select>
        <label className='consultInput' >Žinutė</label>
        <textarea name="message" placeholder="Tuščia" onChange={handleInputChange}></textarea>
        <input className='submitBtn' type="submit" value="Siūsti" />
      </form>
    </div>
    {loading && (
      <div className="loading">
              <Spinner />
      </div>
    )}
  </div>
  );
};

export default function Consult() {
  return (
    <div>
      <ContactUs />
    </div>
  )
}